// react-router-dom components
import { Link } from "react-router-dom";

// prop-types
import PropTypes from "prop-types";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function DefaultFooter({ content }) {
  const { brand, menus, copyright } = content;

  return (
    <MKBox component="footer" sx={{ backgroundColor: "#ffffff", py: 8 }}>
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="flex-start" justifyContent="center">
          {/* Logo */}
          <Grid
            item
            xs={12} // full width on mobile
            md={3} // occupy 3 columns on desktop
            sx={{
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              mb: { xs: 3, md: 0 },
            }}
          >
            <Link to={brand.route}>
              <MKBox
                component="img"
                src={brand.image}
                alt={brand.name}
                maxWidth="10rem"
                width="100%"
                sx={{ objectFit: "contain", height: "auto" }}
              />
            </Link>
          </Grid>

          {/* Menus */}
          {menus.map(({ name: title, items }) => (
            <Grid
              key={title}
              item
              xs={6} // 2 per row on mobile
              sm={6} // still 2 per row on small screens
              md={2} // normal column width on desktop
              sx={{
                textAlign: { xs: "center", md: "left" },
                mb: { xs: 3, md: 0 },
              }}
            >
              <MKTypography
                display="block"
                variant="button"
                fontWeight="bold"
                textTransform="capitalize"
                mb={1}
              >
                {title}
              </MKTypography>
              <MKBox component="ul" p={0} m={0} sx={{ listStyle: "none" }}>
                {items.map(({ name, route, href }) => (
                  <MKBox key={name} component="li" p={0} m={0} lineHeight={1.25}>
                    {href ? (
                      <MKTypography
                        component="a"
                        href={href}
                        target="_blank"
                        rel="noreferrer"
                        variant="button"
                        fontWeight="regular"
                        textTransform="capitalize"
                        sx={{
                          display: "block",
                          py: 0.5,
                          "&:hover": { color: "#1FA2FF" },
                        }}
                      >
                        {name}
                      </MKTypography>
                    ) : (
                      <MKTypography
                        component={Link}
                        to={route}
                        variant="button"
                        fontWeight="regular"
                        textTransform="capitalize"
                        sx={{
                          display: "block",
                          py: 0.5,
                          "&:hover": { color: "#1FA2FF" },
                        }}
                      >
                        {name}
                      </MKTypography>
                    )}
                  </MKBox>
                ))}
              </MKBox>
            </Grid>
          ))}

          {/* Copyright */}
          <Grid item xs={12} sx={{ textAlign: "center", mt: 4 }}>
            {copyright}
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

DefaultFooter.propTypes = {
  content: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.object, PropTypes.array])).isRequired,
};

export default DefaultFooter;
